// Purchase.js

import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap';
import Config from '../Config';

import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import { JsonToExcel } from 'react-json-excel';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import Table from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

// class RowItem extends Component {
//     static defaultProps = {
//         item: null,
//         enable: false,
//         onPress: () => { },
//         style : null
//     }
//     constructor(props) {
//         super(props);
//         this.state = {
//             visible : false
//         };
//     }

//     handleRowClick = () => {
//         this.setState({ visible: !this.state.visible })
//         this.props.onPress(this.props.item);
//         event.preventDefault();
//     }
//     render(){
//         return (
//             <tr onClick={this.handleRowClick} style={this.props.style}>
//             <td>{this.props.item.ID}</td>
//             <td>{this.props.item.EMAIL}
//             { this.state.visible ?
//             <div className="row">
//                 <Form>
//                     <Button variant="primary">환불</Button>
//                     <Button variant="primary">삭제</Button>
//                 </Form>
//             </div>
//             :
//             null
//             }
//             </td>
//             <td>{this.props.item.TOKEN}</td>
//             <td>{this.props.item.PCODE}</td>
//             <td>{this.props.item.QRCODE}</td>
//             <td>{this.props.item.SKU}</td>
//             <td>{this.props.item.BUYDATE}</td>
//             <td>{this.props.item.VALIDDATE}</td>
//             <td>{this.props.item.DDAY}</td>
//             </tr>
//         );
//     }
// };

const className = 'class-name-for-style',
    filename = 'Purchase_Excel-file',
    fields = {
        "ID": "주문번호",
        "EMAIL": "EMAIL",
        "TOKEN": "TOKEN",
        "PCODE": "PCODE",
        "QRCODE": "QRCODE",
        "SKU": "SKU",
        "BUYDATE": "BUYDATE",
        "VALIDDATE": "VALIDDATE",
        "DDAY": "DDAY",
    },
    style = {
        padding: "5px",
        background: "#3c8dbc",
        border: "1px #367fa9",
        borderRadius: "3px",
        padding: "6px 12px",
        color: "#ffffff",
        font: "14px",
        height: "37.64px"
    }

export default class Purchase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sendcount: 0,
            results: [],
            rowlist: [],
            rowCount: 0,
            scrollToIndex: undefined,
            toolbarvisible: false,
            visible: false,
            item: { TITLE: '제목을 입력하세요.', CONTENT: '내용을 입력하세요.', LANGUAGE_CODE: 'ko', COUNTRY_CODE: 'KR' },
            searchText: '',
        };

        this.handleReturn = this.handleReturn.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeContent(event) {
        var item = this.state.item;
        item.CONTENT = event.target.value;
        this.setState({ item: item });
    }

    handleChangeLang(event) {
        var item = this.state.item;
        item.LANGUAGE_CODE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeCountry(event) {
        this.setState({ country: event.target.value });
    }

    fetchData(address, params, callback, revalidate = false, cbError) {

        var chcheoption = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (revalidate) {
            // chcheoption['Cache-Control'] = 'must-revalidate';
        }

        fetch(`${Config.Server}/${address}`, {
            // mode: 'no-cors',
            method: 'POST',
            headers: chcheoption,
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (callback)
                    callback(responseJson.result, responseJson.count);
            })
            .catch((error) => {
                console.error(error);
                cbError(error);
            });
    }

    handleReturn(event) {

        // this.fetchData('insnotice' , {
        //     COUNTRY_CODE: this.state.item.COUNTRY_CODE,
        //     LANGUAGE_CODE: this.state.item.LANGUAGE_CODE,
        //     TITLE: this.state.item.TITLE,
        //     CONTENT: this.state.item.CONTENT
        // }, (result, count) => {
        //     console.log('insnotice=', count);
        //     this.setState({sendcount : count})
        // }, true);    

        event.preventDefault();
    }

    handleRemove(event) {

        // this.fetchData('delnotice' , {
        //     ID : this.state.item.ID,
        //     COUNTRY_CODE: this.state.item.COUNTRY_CODE,
        //     LANGUAGE_CODE: this.state.item.LANGUAGE_CODE
        // }, (result, count) => {
        //     console.log('delnotice=', count);
        //     this.setState({sendcount : count})
        // }, true);    

        event.preventDefault();
    }

    handleRowClick = (item) => {
        this.setState({ toolbarvisible: !this.state.toolbarvisible });
        event.preventDefault();
    }

    componentDidMount() {
        this.fetchData('buylistall', {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({ rowCount: result.length })
            this.setState({ rowlist: result, results: result }, () => {
                this.onClickSearch();
            });
        }, true);
    }

    handleClose = () => {
        console.log('handleClose');
        this.setState({ answervisible: false });
    }

    handleScroll(scrollData) {
        console.log(scrollData);
        //this.fetchMoreData();
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const { rowCount } = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({ scrollToIndex });
    }

    _rowClassName({ index }) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    onClickSearch = () => {
        if (this.state.searchText.trim().length < 1) {
            this.setState({ rowlist: this.state.results });
        } else {
            this.setState({ rowlist: this.state.results.filter(item => item.EMAIL.includes(this.state.searchText.trim())) });
        }
    }

    handleSearchChange = (event) => {
        event.preventDefault(); // form의 기본 제출 동작을 방지합니다.
        var newValue = this.state.searchText;
        newValue = event.target.value;
        this.setState({ searchText: newValue }, () => {
            this.onClickSearch();
        });
    };

    onClickDel = (val) => {
        if (window.confirm(val + " 항목을 삭제 하시겠습니까?")) {
            console.log("Confirmed!");
            Config.fetchData('delpurchase', {
                ID: val
            }, (result, count) => {
                console.log('delpurchase=', count);
                this.componentDidMount();
            }, true);
        }
    }

    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">구매 목록</h3>
                                            </td>

                                            <td width="20"></td>
                                            <td>
                                                <Form style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Form.Control type="title" value={this.state.searchText} onChange={this.handleSearchChange} placeholder="EMAIL을 입력하세요." />
                                                    <Button variant="primary" onClick={this.onClickSearch}>검색</Button>
                                                </Form>
                                            </td>
                                            <td width="16"></td>
                                            <td>
                                                {this.state.rowlist.length > 0 ?
                                                    <JsonToExcel
                                                        data={this.state.rowlist}
                                                        className={className}
                                                        filename={filename}
                                                        fields={fields}
                                                        style={style}
                                                    />
                                                    :
                                                    null
                                                }
                                            </td>
                                            <td width="100"></td>
                                            <td>
                                                {this.state.toolbarvisible ?
                                                    <div className="row">
                                                        <Form>
                                                            {/* <Button variant="primary">환불</Button> */}
                                                            <Button variant="primary">삭제</Button>
                                                        </Form>
                                                    </div>
                                                    :
                                                    null
                                                }
                                            </td>

                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row">
                                        <AutoSizer disableHeight>
                                            {({ width }) => (
                                                <Table
                                                    ref="Table"
                                                    headerClassName={'headerColumn'}
                                                    onRowClick={this.handleRowClick}
                                                    headerHeight={30}
                                                    height={800}
                                                    noRowsRenderer={this._noRowsRenderer}
                                                    overscanRowCount={10}
                                                    rowClassName={this._rowClassName}
                                                    rowHeight={40}
                                                    rowGetter={({ index }) => this.state.rowlist[index]}
                                                    rowCount={this.state.rowlist.length}
                                                    scrollToIndex={this.state.scrollToIndex}
                                                    width={width}>
                                                    <Column
                                                        width={80}
                                                        disableSort
                                                        label="#"
                                                        dataKey="ID"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={300}
                                                        disableSort
                                                        label="EMAIL"
                                                        dataKey="EMAIL"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={300}
                                                        disableSort
                                                        label="TOKEN"
                                                        dataKey="TOKEN"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={80}
                                                        disableSort
                                                        label="PCODE"
                                                        dataKey="PCODE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={280}
                                                        disableSort
                                                        label="QRCODE"
                                                        dataKey="QRCODE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={150}
                                                        disableSort
                                                        label="SKU"
                                                        dataKey="SKU"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="BUYDATE"
                                                        dataKey="BUYDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="VALIDDATE"
                                                        dataKey="VALIDDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="DDAY"
                                                        dataKey="DDAY"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />

                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="삭제"
                                                        dataKey="ID"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => <Button variant="primary" onClick={() => this.onClickDel(cellData)}>삭제</Button>}
                                                        flexGrow={1}
                                                    />
                                                </Table>
                                            )}
                                        </AutoSizer>
                                        {/* <ScrollArea style={{  width: '100%' , height: 700 }}
                                            className="area"
                                            contentClassName="content"
                                            verticalScrollbarStyle={scrollbarStyles}
                                            verticalContainerStyle={scrollbarStyles}
                                            horizontalScrollbarStyle={scrollbarStyles}
                                            horizontalContainerStyle={scrollbarStyles}
                                            smoothScrolling= {true}
                                            minScrollSize={20}
                                            onScroll={this.handleScroll}
                                            >
                                        <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                            <th>#</th>
                                            <th>EMAIL</th>
                                            <th>TOKEN</th>
                                            <th>PCODE</th>
                                            <th>QRCODE</th>
                                            <th>SKU</th>
                                            <th>BUYDATE</th>
                                            <th>VALIDDATE</th>
                                            <th>DDAY</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        { this.state.rowlist.map((item, index) =>
                                            <RowItem key={index} item={item} onPress={this.handleRowClick}/>
                                        )}
                                        </tbody>
                                        </Table>
                                        </ScrollArea> */}
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                {/* <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Purchase.js